export enum UserSignUpFlow {
  Completed = "completed",
  SelfSignUp = "selfSignUp",
  InviteSignUp = "inviteSignUp",
  SubscriptionExpired = "subscriptionExpired",
}

export enum SubscriptionStatus {
  Active = "active",
  Inactive = "inactive",
  Trial = "trial",
}

export enum Role {
  Admin = "admin",
  Dealmaker = "dealmaker",
  Owner = "owner",
  SuperAdmin = "superAdmin",
}

export enum InviteStatus {
  Sent = "sent",
  Revoked = "revoked",
  Accepted = "accepted",
  Expired = "expired",
}

export enum UserConnection {
  Zoom = "zoom",
  GmailRead = "gmailRead",
  GmailWrite = "gmailWrite",
  Calendar = "calendar",
}

export interface UserConnections {
  [UserConnection.Zoom]: boolean | undefined;
  [UserConnection.GmailRead]: boolean | undefined;
  [UserConnection.GmailWrite]: boolean | undefined;
  [UserConnection.Calendar]: boolean | undefined;
  zoomEmail: string | null;
}

export interface Subscription {
  planName: string;
  status: SubscriptionStatus;
  trialEnd: string;
  endedAt: string;
}

export interface App {
  name: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  stats: {
    emailsAnalyzed?: number;
    updatedAt?: string;
    installHistory?: {
      action: string;
      date: string;
      version: string;
    };
  };
}

export interface Organization {
  name: string;
  nameType: string;
  url: string;
  primaryEmail: string;
  avatar: string;
  orgId: string;
  createdAt: string;
  updatedAt: string;
  deleted: boolean;
  inviteStatus: "sent" | "expired";
  inviteExpires: string;
  location: string | null;
  usersCount: number | string;
  maxUsersCount: number | string;
  ownerName: string;
  adminNames: string[];
  acquisitionSource: string | null;
  timezone: string | null;
  activeUsersCount: number | null;
  inactiveUsersCount: number | null;
  teamsCount: number | null;
  enabledFeatures: string[];
  isFunctionalityEnabled?: boolean;
  subscription: Subscription | null;
  signupType: string;
}

export interface User {
  name: string;
  firstName: string;
  lastName: string;
  avatar: string;
  phoneNumber: string;
  timezone: string;
  title: string;
  userId: string;
  orgId: string;
  email: string;
  apps: App[];
  role: Role;
  lastSignIn: string;
  lastActivity: string;
  createdAt: string;
  updatedAt: string;
  stats: {
    emailsAnalyzed: number;
    updatedAt: string;
  };
  status?: string;
  deleted: boolean;
  active: boolean;
  isEmailVerified: boolean;
  inviteStatus: InviteStatus;
  inviteExpires: string;
  jwt?: string;
  updatedAvatar?: string;
  userHash: string;
  showDashboardWelcomePopup: boolean;
  showInstallExtensionPopup: boolean;
  isAddinInstalled: boolean;
  isChromeExtensionInstalled: boolean;
  metadata?: {
    features?: Array<{
      enabled: boolean;
      isInPackage: boolean;
      name: string;
    }>;
  };
}

export interface GetCustomTokenRequestBody {
  authCode: string;
}

export interface AuthState {
  isLoading: {
    customToken: boolean;
    signIn: boolean;
    signOut: boolean;
    identity: boolean;
    userConnections: boolean;
    userFlags: boolean;
  };
  isError: {
    customToken: boolean;
    signIn: boolean;
    signOut: boolean;
    identity: boolean;
    userConnections: boolean;
    userFlags: boolean;
  };
  customToken: string | null;
  isLoggedIn: boolean;
  isInitialized: boolean;
  user: User | null;
  org: Organization | null;
  userSignUpFlow: UserSignUpFlow | null;
  userConnections: UserConnections | null;
}
